import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa00ee0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "eval-result-card"
}
const _hoisted_2 = { class: "eval-result-card__summary" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "eval-result-card__title" }, "实时评估结果", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "eval-result-card__score-label" }, "总分", -1))
const _hoisted_5 = { class: "eval-result-card__total" }
const _hoisted_6 = { class: "eval-result-card__full" }
const _hoisted_7 = {
  key: 0,
  class: "eval-result-card__star-tag"
}
const _hoisted_8 = {
  key: 1,
  class: "eval-result-card__range"
}
const _hoisted_9 = {
  key: 0,
  class: "eval-result-card__items"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.result.totalScore), 1),
          _createElementVNode("span", _hoisted_6, "/ " + _toDisplayString(_ctx.result.fullScore) + "分", 1),
          (_ctx.starTagText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.starTagText), 1))
            : _createCommentVNode("", true),
          (_ctx.result.starRangeText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.result.starRangeText) + "分", 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.items.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: index,
                  class: "eval-result-card__item"
                }, _toDisplayString(item.label || item.indicatorName) + "：" + _toDisplayString(item.score) + "分 ", 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}